import type { OrgSegment, TenantSegment } from '@/lib/routeScope'
import { createContext, useContext } from 'react'

/**
 * What the URL names, as it spells it. Segments rather than identifiers, because that is what the
 * router handed the layout and what nearly every consumer does with them: build another URL. A
 * consumer that needs to ask the API about one resolves it with `resolveOrgId` or `resolveTenantId`.
 */
export interface RouteContext {
	tenantId?: TenantSegment
	orgId?: OrgSegment
}

// Component-free module keeps this context's identity stable across Fast Refresh;
// co-locating it with a component export makes HMR mint a new context and desync the provider.
export const RouteContext = createContext<RouteContext | null>(null)

export function useRouteContext(): RouteContext {
	const context = useContext(RouteContext)
	if (!context) {
		throw new Error('useRouteContext must be used within RouteContextLayout')
	}
	return context
}
